// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-d33e394a]{font-size:16px;font-weight:600}.title .default-bar[data-v-d33e394a]{width:3px;height:14px;background:#5088ff;display:block;margin-right:8px}.right-btn[data-v-d33e394a]{cursor:pointer;color:#5088ff;font-size:12px}", ""]);
// Exports
module.exports = exports;
